module.exports = $;


/*****************
 ** WEBPACK FOOTER
 ** external "$"
 ** module id = 2
 ** module chunks = 0
 **/